import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'widget-ilerleme-halka',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="halka-kapsayici" [style.width.px]="boyut()" [style.height.px]="boyut()">
      <svg [attr.viewBox]="'0 0 ' + boyut() + ' ' + boyut()">
        <circle
          [attr.cx]="merkez()" [attr.cy]="merkez()" [attr.r]="yaricap()"
          fill="none" stroke="rgba(128,128,128,0.15)" [attr.stroke-width]="kalinlik()"
        />
        <circle
          class="dolgu"
          [attr.cx]="merkez()" [attr.cy]="merkez()" [attr.r]="yaricap()"
          fill="none" [attr.stroke]="efektifRenk()" [attr.stroke-width]="kalinlik()"
          stroke-linecap="round"
          [attr.stroke-dasharray]="cevre()"
          [attr.stroke-dashoffset]="offset()"
          [style.transform]="'rotate(-90deg)'"
          [style.transform-origin]="'50% 50%'"
        />
      </svg>
      <span class="merkez-deger" [style.color]="efektifRenk()" [style.font-size.px]="boyut() * 0.22">
        {{ clampYuzde() }}%
      </span>
    </div>
  `,
  styles: [`
    :host { display: inline-block; }
    .halka-kapsayici { position: relative; display: inline-flex; align-items: center; justify-content: center; }
    svg { display: block; }
    .dolgu { transition: stroke-dashoffset 0.6s cubic-bezier(0.4, 0, 0.2, 1), stroke 0.3s; }
    .merkez-deger {
      position: absolute; font-weight: 700;
      top: 50%; left: 50%; transform: translate(-50%, -50%);
    }
  `],
})
export class IlerlemeHalkaComponent {
  yuzde = input(0);
  renk = input('#1890ff');
  boyut = input(120);

  clampYuzde = computed(() => Math.max(0, Math.min(100, this.yuzde())));
  merkez = computed(() => this.boyut() / 2);
  kalinlik = computed(() => Math.max(4, this.boyut() * 0.08));
  yaricap = computed(() => (this.boyut() - this.kalinlik()) / 2);
  cevre = computed(() => 2 * Math.PI * this.yaricap());
  offset = computed(() => this.cevre() * (1 - this.clampYuzde() / 100));

  efektifRenk = computed(() => {
    const y = this.clampYuzde();
    if (y < 30) return '#f5222d';
    if (y < 70) return '#faad14';
    return this.renk();
  });
}
